module.exports = __webpack_public_path__ + "static/media/IMG_0101.9026b026.jpg";